import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Blog = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    arrows: false,
    responsive: [
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <>
      <div className="blogs-generator content-wrapper">
        <h2>Our Blogs</h2>

        <div
          className="slider-wrapper blog-cards-slider"
          style={{ minHeight: "300px" }}
        >
          <div className="slider-track">
            <div className="slider-section">
              <Slider {...settings} className="slider custom-blog-slider">
                {/* Slide 1 */}
                <div className="slide" style={{ padding: "0 9px" }}>
                  <a href="#">
                    <div className="blog-card">
                      <div className="image-container">
                        <img
                          src="assets/pwa-static/pwa/images/blogs/blog-3.webp"
                          alt="Blog"
                          className="card-image"
                        />
                      </div>
                      <div className="text-container">
                        <div className="text-details">
                          <p className="post-category">Money management</p>
                          <p className="post-title">
                            5 best ways to make passive income in 2025
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* Slide 2 */}
                <div className="slide" style={{ padding: "0 9px" }}>
                  <a href="#">
                    <div className="blog-card">
                      <div className="image-container">
                        <img
                          src="assets/pwa-static/pwa/images/blogs/Header-img-personal-loan.webp"
                          alt="Blog"
                          className="card-image"
                        />
                      </div>
                      <div className="text-container">
                        <div className="text-details">
                          <p className="post-category">Personal loans</p>
                          <p className="post-title">
                            Guide to know everything about personal loan
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* Slide 3 */}
                <div className="slide" style={{ padding: "0 9px" }}>
                  <a href="#">
                    <div className="blog-card">
                      <div className="image-container">
                        <img
                          src="assets/pwa-static/pwa/images/blogs/Dipping-into-savings-vs-loan.webp"
                          alt="Blog"
                          className="card-image"
                        />
                      </div>
                      <div className="text-container">
                        <div className="text-details">
                          <p className="post-category">Personal loans</p>
                          <p className="post-title">
                            Use savings or take a loan — what is better?
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>

                {/* Slide 4 */}
                <div className="slide" style={{ padding: "0 9px" }}>
                  <a href="#">
                    <div className="blog-card">
                      <div className="image-container">
                        <img
                          src="assets/pwa-static/pwa/images/blogs/blog-4.webp"
                          alt="Blog"
                          className="card-image"
                        />
                      </div>
                      <div className="text-container">
                        <div className="text-details">
                          <p className="post-category">Money management</p>
                          <p className="post-title">
                            How to analyze & check your financial strength
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blog;
